<template>
  <div class="declaracao-cadastro">
    <Dialog :visible.sync="showCadastro" :modal="true" :closable="false"
      :style="{ width: '900px', overflow: 'hidden' }">
      <h1 class="titulo-header">
        Nova Declaração
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showCadastro = false" />
      </h1>
      <div id="topo" >
        <error-list :erros="erros" v-if="erros" />

        <div class="row">
          <div class="col-md-2 mb-2">
            <label for="descServico">Ano:</label>
            <span class="p-fluid">
              <InputText v-model="declaracao.ano" disabled />
            </span>
          </div>
          <div class="col-md-2 mb-2">
            <label for="descServico">Mês:</label>
            <span class="p-fluid">
              <InputText v-model="declaracao.mes" disabled />
            </span>
          </div>

          
        </div>

        <div class="row">
          <div class="col-md-10 mb-2">
            <label for="pedagio">Praça Pedágio: *</label>
            <span class="p-fluid">
              <AutoComplete id="pedagio" v-model="selectedPedagio" :dropdown="true" :suggestions="filteredPedagios"
                field="nome" placeholder="Pesquisar" @complete="searchPedagio($event)">

              </AutoComplete>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 mb-2">
            <label for="tarifa">Categoria: *</label>
            <span class="p-fluid">
              <AutoComplete id="tarifa" v-model="selectedCategoria" :dropdown="true" :suggestions="filteredCategorias"
                field="nome" placeholder="Pesquisar" @complete="searchCategoria($event)"
                @item-select="atualizarDadosTelaCategoria()">

              </AutoComplete>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 mb-2">
            <label for="tarifa">Tarifa: *</label>
            <span class="p-fluid">
              <AutoComplete id="tarifa" v-model="selectedTarifa" :dropdown="true" :suggestions="filteredTarifas"
                field="nome" placeholder="Pesquisar" @complete="searchTarifa($event)"
                @item-select="atualizarDadosTelaTaxa()">

              </AutoComplete>
            </span>
          </div>
        </div>
        <div class="row" v-if="selectedTarifa && selectedTarifa.id">
          <div class="col-md-8 mb-2">
            <label for="tarifa">Serviço: </label>
            <span class="p-fluid">
              <input id="servico" name="servico" :value="servico" class="p-inputtext" disabled="true" />
            </span>
          </div>
          <div class="col-md-3 mb-2">
            <label for="tarifa">Alíquota: </label>
            <span class="p-fluid">
              <input id="aliquota" name="aliquota" :value="aliquotaServico" class="p-inputtext" disabled="true" />
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 mb-2">
            <label for="quantidade">Quantidade: *</label>
            <span class="p-fluid">
              <InputText id="quantidade" name="quantidade" v-model="quantidade" class="p-inputtext input-right" />
            </span>
          </div>
          <div class="col-md-3 mb-2">
            <label for="valor">Valor:</label>
            <span class="p-fluid">
              <money id="valor" name="valor" v-model="valorTarifa" v-bind="money" disabled="true"
                class="p-inputtext input-right"></money>
            </span>
          </div>
          <div class="col-md-3 mb-2">
            <label for="valor">Valor Base Cálculo:</label>
            <span class="p-fluid">
              <money id="valor" name="valor" :value="valorBaseCalculo" v-bind="money" disabled="true"
                class="p-inputtext input-right"></money>
            </span>
          </div>
          <div class="col-md-3 mb-2">
            <label for="valor">Valor ISS:</label>
            <span class="p-fluid">
              <money id="valor" name="valor" :value="valorIss" v-bind="money" disabled="true"
                class="p-inputtext input-right"></money>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 mb-2">
            <label for="descServico">Descrição: *</label>
            <span class="p-fluid">
              <textarea id="descServico" name="descServico" v-model="declaracaoConcessionaria.observacao" rows="5" />
            </span>
          </div>
        </div>

        <hr />

        <div class="botoes-avancar-voltar" style="margin-top: 10px">
          <Button @click="gravar()" href="#topo" type="button" label="Declarar"
            class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading" />
          <Button @click="showCadastro = false" type="button" label="Fechar"
            class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import money from "../conf/config.money";
import percent from "../conf/config.percent";
import LoginService from "../services/acesso/login.service";
import Declaracao from "../models/tributario/Declaracao";
import DeclaracaoConcessionaria from "../models/tributario/DeclaracaoConcessionaria";
import DeclaracaoConcessionariaService from "../services/tributario/declaracao.concessionaria.service";
import TarifaService from "../services/nfse/tarifa.service";
import PedagioService from "../services/nfse/pedagio.service";

export default {
  name: "DeclaracaoConcessionariaCadastro",

  data() {
    return {
      money: money,
      percent: percent,
      loading: false,
      erros: [],
      idCliente: null,
      showCadastro: false,
      currentUser: null,
      declaracao: new Declaracao(),
      declaracaoConcessionaria: new DeclaracaoConcessionaria(),
      selectedPedagio: null,
      selectedCategoria: null,
      selectedTarifa: null,
      filteredPedagios: [],
      filteredCategorias: [],
      filteredTarifas: [],
      showOrientacoes: false,
      quantidade: 1,
      aliquota: 5,
      valorTarifa: 0,
      tarifaSelecionada: null
    };
  },

  created() {
    this.currentUser = LoginService.currentUserValue;
    this.idCliente = this.currentUser.usuario.idCliente;
    this.tarifaSelecionada = null;
    this.$root.$on("declaracaoSimplificada:novo", () => {
      this.novo();
    });
  },

  methods: {
    rowClass() {
      return null;
    },
    lineClass() {
      return null;
    },
    novo() {
      this.showCadastro = true;
      this.erros = [];
      this.declaracao.ano = this.$parent.filtroAno.key;
      this.declaracao.mes = this.$parent.filtroMes.key;
      this.declaracao.idContribuinte = this.currentUser.contribuinte.idContribuinte;
      this.declaracao.idUsuario = this.currentUser.usuario.idUsuario;
      this.declaracao.idCliente = this.currentUser.usuario.idCliente;
      this.declaracao.valorServico = 0;
      this.declaracao.valorDesconto = 0;
      this.declaracao.aliquota = 0;
      this.declaracao.observacao = "";
      this.declaracaoConcessionaria = new DeclaracaoConcessionaria();
      this.quantidade = 1;
      this.valorTarifa = 0;
      this.selectedCategoria = null;
      this.selectedPedagio = null;
      this.selectedTarifa = null;
      this.selectedServico = null;
    },
    searchPedagio(event) {
      setTimeout(async () => {
        this.filteredPedagios = await PedagioService.findAllPedagiosByFiltro(
          event.query
        );
        console.log(this.selectedPedagio);
      }, 250);
    },
    searchTarifa(event) {
        setTimeout(async () => {
          this.filteredTarifas = await TarifaService.findAllTarifasByFiltro(
            this.currentUser.usuario.idCliente,
            (this.selectedCategoria && this.selectedCategoria.id) ? this.selectedCategoria.id : null,
            event.query
          );
        }, 250);
    },
    searchCategoria(event) {
      setTimeout(async () => {
        this.filteredCategorias = await TarifaService.findAllCategoriasByFiltro(
          this.currentUser.usuario.idCliente,
          event.query
        );
      }, 250);
    },
    atualizarDadosTelaCategoria() {
      this.selectedTarifa = null;
    },
    atualizarDadosTelaTaxa() {
      this.processando(true);
      this.tarifaSelecionada = null;
      if (this.selectedTarifa && this.selectedTarifa.id) {
        this.tarifaSelecionada = this.selectedTarifa;
        this.valorTarifa = this.selectedTarifa.valorPercentual;
      }
      this.processando(false);
    },
    async gravar() {
      
      if(!this.selectedPedagio) {
        this.$root.$emit('alert:warning', 'Selecione um pedágio');
        return;
      }else if(!this.selectedTarifa) {
        this.$root.$emit('alert:warning', 'Selecione uma tarifa');
        return;
      }else if(this.quantidade <= 0) {
        this.$root.$emit('alert:warning', 'Quantidade inválida');
        return;
      }else if(this.declaracaoConcessionaria.observacao == null || this.declaracaoConcessionaria.observacao == '') {
        this.$root.$emit('alert:warning', 'Informe uma Descrição');
        return;
      }
      this.processando(true);
      await this.declarar();
      this.processando(false);
      
    },
    async declarar() {
      this.processando(true);
      this.declaracaoConcessionaria.quantidade = this.quantidade
      this.declaracaoConcessionaria.valor = this.selectedTarifa.valorPercentual;

      this.declaracaoConcessionaria.idTarifa = this.selectedTarifa;
      this.declaracaoConcessionaria.idPedagio = this.selectedPedagio;

      DeclaracaoConcessionariaService.declarar(
        this.currentUser.usuario.idCliente,
        this.currentUser.usuario.idUsuario,
        this.currentUser.contribuinte.idContribuinte,
        this.declaracao.ano,
        this.declaracao.mes,
        "N",
        this.declaracaoConcessionaria
      ).then(
        (response) => {
          console.log(response);
          this.$root.$emit("alert:success", "Declaração gerada com sucesso!");
          this.processando(false);
          this.$parent.pesquisar();
          this.showCadastro = false;
        },
        (error) => {
          console.log(error);
          let errorMessage = "Erro ao gerar Declaração!";
          this.$root.$emit("alert:warn", "");
          if (error.response) {
            const errors = Array.isArray(error.response.data)
              ? error.response.data
              : [error.response.data];

            errors.forEach(err => {
              this.$toast.add({
                severity: "error",
                summary: "Erro",
                detail: err,
                life: 5000
              });
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Erro",
              detail: errorMessage,
              life: 5000
            });
          }
          this.processando(false);
        }
      );
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },

    
    roundToTwo(num) {
      return +(Math.round(num + "e+2") + "e-2");
    },
  },

  computed: {
    isBloqueado() {
      return this.currentUser && this.currentUser.idBolBloquearSistema && this.currentUser.idBolBloquearSistema === 'S';
    },
    servico() {
      return ((this.tarifaSelecionada && this.tarifaSelecionada.servicoItem && this.tarifaSelecionada.servicoItem.id) ? this.tarifaSelecionada.servicoItem.idServico.codigoServico + ' - ' + this.tarifaSelecionada.servicoItem.idServico.nomeServico : null);
    },
    aliquotaServico() {
      return ((this.tarifaSelecionada && this.tarifaSelecionada.servicoItem && this.tarifaSelecionada.servicoItem.id) ? this.tarifaSelecionada.servicoItem.valor + '%' : null);
    },
    valorBaseCalculo() {
      return this.roundToTwo(
        this.valorTarifa * this.quantidade
      );
    },

    valorIss() {
      return (this.tarifaSelecionada && this.tarifaSelecionada.id) ? this.roundToTwo((this.valorBaseCalculo * this.tarifaSelecionada.servicoItem.valor) / 100) : 0;
    },

  }
};
</script>

<style scoped>
.scrolable-dialog {
  padding-right: 25px;
  width: 90vw;
  max-height: 65vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.p-inputtext:disabled {
  color: #a6a6a6;
  border-color: #a6a6a6;
}

textarea {
  width: 100%;
  border-radius: 12px;
}
</style>
